import React, { useContext, useState } from "react";
import { EndPage, UserEntryPage } from ".";
import { putItem, User } from "../aws";
import { EventCategory } from "../analytics";
import { FadeTransitionWrapper } from "../components";
import { GameContext, GameContextProps } from "../contexts";
import { parseStoryJson } from "../story";
import { GamePage } from "./GamePage";

/**The containing component for app content. At this level, any subpage meant to display before the game starts can be placed. */
export const MainPage = () => {
    const story = parseStoryJson();
    const chapters = story.chapters;
    const numberOfChapters = chapters.length - 1;
    const [currentChapterNumber, setCurrentChapterNumber] = useState(0);
    const [isLastChapter, setIsLastChapter] = useState(false);
    const [isFormSubmitted, setFormSubmitted] = useState(false);
    const { analytics, modifyEnergy } = useContext(GameContext) as GameContextProps;

    const incrementChapter = () => {
        if (currentChapterNumber >= numberOfChapters) {
            analytics?.recordEvent(EventCategory.FINISH_GAME,"");
            setIsLastChapter(true);
            return;
        }
        setCurrentChapterNumber(prevChapter => prevChapter + 1);
    }

    const getTotalBeats = () => {
        const initialBeatCount = 0;
        return chapters.reduce((prevCount, currentChapter) => {
            return prevCount + currentChapter.chapterBeats.length;
        }, initialBeatCount);
    }

    const onFormSubmitted = (userParams: User) => {
        console.log('onformsubmitted');
        setFormSubmitted(!isFormSubmitted);
        try {
            putItem(userParams);
        } catch (error: any) {
            console.log(error.message);
        }
    }

    const onResetStory = () => {
        setCurrentChapterNumber(0);
        setIsLastChapter(false);
        modifyEnergy(10);
        analytics?.recordEvent(EventCategory.RESTART,"");
    }

    return (
        <div className="main">
            {isLastChapter ? 
                <FadeTransitionWrapper willShowElement={true}>
                    <EndPage onRestartGame={onResetStory}/>
                </FadeTransitionWrapper>
            :
                <div>
                    {isFormSubmitted ?
                    <FadeTransitionWrapper willShowElement={true}>
                        <GamePage 
                        currentChapter={chapters[currentChapterNumber]} 
                        onChapterEnded={incrementChapter} 
                        isLastChapter={isLastChapter} 
                        numberOfBeats={getTotalBeats()}
                        onResetStory={onResetStory}
                        />
                    </FadeTransitionWrapper>
                        : <UserEntryPage onFormSubmitted={onFormSubmitted}/>
                    }
                </div>
            }
        </div>
    );
}